import React, { Component } from 'react';
import AuthMiddleware from '../../store/middleware/authMiddleware';
import { connect } from 'react-redux';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import RouteActions from '../../store/actions/routeActions';
import { SHA256 } from 'crypto-js';

class ManualSignIn extends Component {
    constructor(props){
        super(props);
        this.state = {
            email : "",
            password : "",
            loader : false,
            signInError : false,
            error : ""
        }
        props.routes(props.history);
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.user){
            this.props.history.replace(`/home/${nextProps.user.panacloudid}`);
        }
        if(nextProps.error){
            this.setState({
                signInError : true,
                error : nextProps.error,
                loader : false
            })
        }
    }

    submission() {
        if (this.state.email !== "" && this.state.password !== "") {
            let { email, password } = this.state;
            var hashPassword = SHA256(password).toString();
            this.props.signin(email, hashPassword);
            this.setState({
                loader: true,
            })
        }
    }

    render(){
        return (
            <div style={{ top: "25%", justifyContent: "center", alignItems: "center", display: "flex", width: "100%", flexDirection: "column", position: "absolute" }}>
                <Paper style={{ padding: "30px", maxWidth: "50%", minWidth : "50%" }}>
                    <Typography style={{ fontWeight: "bold", fontSize: "30px" }} >
                        SignIn
                    </Typography>

                    <TextField 
                        margin="normal"
                        label = 'Enter Email'
                        type="email"
                        fullWidth
                        required
                        onChange={(text) => this.setState({ email : text.target.value, signInError: false })}
                    />

                    <TextField 
                        margin="normal"
                        label = 'Enter Password'
                        type="password"
                        fullWidth
                        required
                        onChange={(text) => this.setState({ password : text.target.value, signInError: false })}
                    />
                        
                    <Typography style={this.state.signInError ? { display: "block", color: 'red', fontSize: '12px' } : { display: "none" }}>* {this.state.error}</Typography>
                        
                    {/* {this.state.loader ? 
                        <div style={{ display: "flex", justifyContent: "center", height : '0vh' }}>
                            <CircularProgress size={40} thickness={3} style={{color : "#13a89e"}}/>
                        </div> 
                        : */}
                        <Button disabled={this.props.buttonDisable ? true : null } color={this.props.buttonDisable ? null : "primary"} variant="contained" style={{ float: "right", marginTop : "2%", backgroundColor : "#13a89e"}} onClick={() => this.submission()}> Sign In </Button>
                    {/* } */}
                </Paper>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        user : state.authReducer.user,
        error: state.authReducer.iserror,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        signin: (email, password) => { dispatch(AuthMiddleware.manualSignInMiddleware(email, password)) },
        routes : (history) => { dispatch(RouteActions.AppRoute(history))},
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ManualSignIn);



// WEBPACK FOOTER //
// ./src/container/ManualSignIn/manualsignin.js